<template>
  <div class="app-option-box" :class="[{'diactivated': disableNext}, option.class]">
    <div class="options-box">
      <div class="option-box-head" v-html="option.head">
      </div>
      <div class="option-box-content" v-html="option.innerContent">
      </div>
      <div class="option-box-button-column">
        <b-overlay v-if="showNext" class="btn-next-overlay" spinner-small>
          <div v-if="booked && !terminated" class="option-info">
            <slot  name="btnCancel"><p class="active-option">AKTIV</p></slot>
            <p v-if="!isService">bis {{possibleChangingDate}}</p></div>
          <div v-if="booked && terminated" class="option-info"> <slot  name="terminated"><p class="terminated-option">GEKÜNDIGT</p></slot><p>Läuft aus am <br>{{possibleChangingDate}}</p></div>
          <b-button v-if="booked && cancelable" @click="cancel" :class="'btn-next btn' + getType" type="button" variant="primary" :disabled="disableNext === true">
            <slot  name="btnCancel" v-if="isService">Deaktivieren</slot>
            <slot  name="btnCancel" v-if="!isService">Kündigen</slot>
          </b-button>
          <b-button v-if="bookable" @click="book" :class="'btn-next btn' + getType" type="button" variant="primary" :disabled="disableNext === true">
            <slot  name="btnBook" v-if="isService">Aktivieren</slot>
            <slot  name="btnBook" v-if="!isService">Jetzt buchen</slot>
          </b-button>
        </b-overlay>
        <div class="status-in-progress" v-else>
          <slot name="txtInProgress"><h4>In Verarbeitung</h4></slot>
        </div>
      </div>
    </div>
    <slot name="txtConflict" v-if="hasConflict"></slot>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'OptionBox',
  components: {
  },
  mixins: [
    slotProxy()
  ],
  computed: {
    isService: function () {
      return this.option.type === 'service'
    },
    booked: function () {
      if (this.isService) {
        return this.option.serviceOption?.anonymousCallRejection || false
      }
      return (this.option.option !== undefined && this.option.option.__typename === 'BookedTariffoption')
    },
    cancelable: function () {
      if (this.isService) {
        return this.option.serviceOption?.anonymousCallRejection || false
      }
      return this.option.option?.cancelable || false
    },
    terminated: function () {
      return this.option.option?.statusKey === 'TER'
    },
    bookable: function () {
      if (this.isService) {
        return !this.booked
      }
      return (this.option.option !== undefined && this.option.option.__typename === 'BookableTariffoption') || this.option.option === undefined
    },
    showNext: function () {
      return this.option.option?.__typename === 'BookableTariffoption' || this.option.option === undefined || this.option.option.__typename === 'BookedTariffoption'
    },
    disableNext: function () {
      return ((this.option.option === undefined || (!this.booked && !this.bookable)) && !this.isService) || this.option.option?.conflictWithCurrent === true || this.loading
    },
    loading: function () {
      return this.option?.loading === true
    },
    hasConflict: function () {
      return this.option.option?.conflictWithCurrent === true
    },
    getType: function () {
      if (this.option.option !== undefined && this.option.option.__typename === 'BookedTariffoption') {
        return '-' + this.option.option.stateFlag
      }
      return '-green'
    },
    possibleChangingDate: function () {
      return this.option.option?.possibleChangingDate || ''
    }
  },
  methods: {
    book () {
      this.$emit('next', { option: this.option, type: 'book' })
    },
    cancel () {
      this.$emit('next', { option: this.option, type: 'cancel' })
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
